(function() {
    'use strict';

    angular
        .module('nasracApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'datatables',
            'datatables.buttons',
            'datatables.factory',
            'datatables.bootstrap',
            'datatables.colreorder',
            'datatables.columnfilter',
            'ods-lib',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.tinymce',
            'ui.router.tabs',
            'dndLists',
            'angulartics', 'angulartics.piwik',
            'ngIdle'

        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
